import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon, CheckCircle2Icon, CircleIcon, WalletIcon } from 'lucide-react';
const shoppingCategories = [{
  title: 'Proteínas Económicas',
  items: ['Huevos (cartón grande)', 'Atún o sardinas en lata (en agua o aceite de oliva)', 'Pechuga o muslos de pollo', 'Lentejas y garbanzos (secos rinden más)', 'Tofu (opcional)']
}, {
  title: 'Verduras (Frescas o Congeladas)',
  items: ['Espinaca o acelga', 'Brócoli (congelado es más barato)', 'Calabacín / Calabaza', 'Zanahorias (muy económicas)', 'Tomate, cebolla y ajo', 'Pepino']
}, {
  title: 'Frutas',
  items: ['Limones', 'Manzanas (comprar por kilo)', 'Naranjas o mandarinas', 'Frutos rojos (congelados son más económicos y duran más)', 'Aguacate (buscar de temporada)']
}, {
  title: 'Granos, Semillas y Grasas',
  items: ['Avena natural en hojuelas', 'Arroz integral', 'Semillas de chía y linaza (comprar a granel)', 'Nueces o almendras (a granel)', 'Aceite de oliva extra virgen (inversión principal)']
}, {
  title: 'Despensa y Extras',
  items: ['Canela en polvo', 'Cúrcuma en polvo', 'Jengibre (fresco o en polvo)', 'Yogur natural sin azúcar o Kéfir', 'Chocolate amargo (85%+)']
}];
export function ShoppingList() {
  const [checkedItems, setCheckedItems] = useState<Set<string>>(new Set());
  const toggleItem = (item: string) => {
    const newChecked = new Set(checkedItems);
    if (newChecked.has(item)) {
      newChecked.delete(item);
    } else {
      newChecked.add(item);
    }
    setCheckedItems(newChecked);
  };
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-wellness-cream relative" data-id="element-163">
      <div className="max-w-6xl mx-auto" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-165">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-wellness-sage/30 text-wellness-primary mb-6" data-id="element-166">
            <ShoppingCartIcon className="w-8 h-8" data-id="element-167" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-168">
            Lista de Compras Económica
          </h2>
          <p className="text-xl text-wellness-text/80 max-w-2xl mx-auto" data-id="element-169">
            Ingredientes accesibles y fáciles de encontrar para tus 14 días de
            desinflamación.
          </p>
        </motion.div>

        {/* Economy Tips Banner */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-amber-50 border border-amber-200 rounded-2xl p-6 mb-12 flex flex-col sm:flex-row gap-4 items-start sm:items-center" data-id="element-170">
          <div className="p-3 bg-amber-100 text-amber-700 rounded-xl shrink-0" data-id="element-171">
            <WalletIcon className="w-6 h-6" data-id="element-172" />
          </div>
          <div data-id="element-173">
            <h4 className="text-lg font-semibold text-amber-900 mb-1" data-id="element-174">
              Tips para ahorrar:
            </h4>
            <p className="text-amber-800/80" data-id="element-175">
              Compra legumbres secas, semillas a granel y vegetales/frutos rojos
              congelados. Son igual de nutritivos, duran más y cuestan una
              fracción del precio.
            </p>
          </div>
        </motion.div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-176">
          {shoppingCategories.map((category, idx) => <motion.div key={category.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-[1.5rem] p-6 shadow-organic-sm border border-wellness-sage/30" data-id="element-177">
              <h3 className="text-xl font-serif font-semibold text-wellness-primary mb-4 pb-2 border-b border-wellness-sage/30" data-id="element-178">
                {category.title}
              </h3>
              <ul className="space-y-3" data-id="element-179">
                {category.items.map(item => {
              const isChecked = checkedItems.has(item);
              return <li key={item} className="flex items-start gap-3 cursor-pointer group" onClick={() => toggleItem(item)} data-id="element-180">
                      <button className="mt-0.5 shrink-0 text-wellness-medium group-hover:text-wellness-primary transition-colors" data-id="element-181">
                        {isChecked ? <CheckCircle2Icon className="w-5 h-5 text-wellness-accent" data-id="element-182" /> : <CircleIcon className="w-5 h-5 text-wellness-sage" data-id="element-183" />}
                      </button>
                      <span className={`text-lg transition-all duration-200 ${isChecked ? 'text-wellness-text/40 line-through' : 'text-wellness-text/90'}`} data-id="element-184">
                        {item}
                      </span>
                    </li>;
            })}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}